import React from "react";
import DocumentManagement from "../../components/shared/DocumentManagement";
import { BarChart3, Shield, Eye, Download } from "lucide-react";

const AdminDocumentManagement = () => {
    const documentSections = [
        {
            id: "system-performance",
            title: "System Performance Report",
            icon: BarChart3,
            description: "System-wide performance metrics and analytics"
        },
        {
            id: "audit-log",
            title: "Audit Log Report",
            icon: Shield,
            description: "Complete audit trail of system activities"
        }
    ];

    return (
        <>
            {/* Document Reports Section */}
            <div className="bg-white shadow">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center py-4">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">
                                Document Management
                            </h1>
                            <p className="text-sm text-gray-500">
                                Manage bond documents and reports
                            </p>
                        </div>
                    </div>
                </div>
            </div>



            {/* Bond Documents Section */}
            <DocumentManagement role="admin" />
        </>
    );
};

export default AdminDocumentManagement;
